import * as React from 'react'

const SvgTextHighlightIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 9.375H3.125A1.875 1.875 0 011.25 7.5V6.25c0-1.036.84-1.875 1.875-1.875H6.25v-1.25a.625.625 0 00-.625-.625h-3.75V1.25h3.75c1.036 0 1.875.84 1.875 1.875v6.25zm-4.375-3.75a.625.625 0 00-.625.625V7.5c0 .345.28.625.625.625H6.25v-2.5H3.125zm9.375 8.75v1.25c0 .345.28.625.625.625h3.125v-2.5h-3.125a.625.625 0 00-.625.625zM1.25 18.75h17.5V1.25l-17.5 17.5zM17.5 17.5h-4.375a1.875 1.875 0 01-1.875-1.875v-1.25c0-1.036.84-1.875 1.875-1.875h3.125v-1.25a.625.625 0 00-.625-.625h-3.75v-1.25h3.75c1.035 0 1.875.84 1.875 1.875v6.25z"
      fill="#163250"
    />
  </svg>
)

export default SvgTextHighlightIcon
